export const statusOptions = [
    {
        label: 'Approved', value: 'APPROVED', group: "Status"
    },
    {
        label: 'In appeal', value: 'IN_APPEAL', group: "Status"
    },
    {
        label: 'Pending', value: 'PENDING', group: "Status"
    },
    {
        label: 'Pending deletion', value: 'PENDING_DELETION', group: "Status"
    },
    {
        label: 'Deleted', value: 'DELETED', group: "Status"
    },
    {
        label: 'Disabled', value: 'DISABLED', group: "Status"
    },
    {
        label: 'Paused', value: 'PAUSED', group: "Status"
    },
    {
        label: 'Limit exeeded', value: 'LIMIT_EXCEEDED', group: "Status"
    }
];

export const cratioStatusOptions = [
    {
        label: 'Mark as Active', value: 'ACTIVE'
    },
    {
        label: 'Mark as Archive', value: 'ARCHIVE'
    },
];

export const cratioStatusFilterOptions = [
    {
        label: 'All Active', value: 'ACTIVE'
    },
    {
        label: 'All Archive', value: 'ARCHIVE'
    },
];

export const statusOptionsObject = {
    'APPROVED': 'Approved',
    'IN_APPEAL':'In appeal',
    'PENDING': 'Pending',
    'PENDING_DELETION': 'Pending deletion',
    'DELETED': 'Deleted',
    'DISABLED': 'Disabled',
    'PAUSED': 'Paused',
    'LIMIT_EXCEEDED': 'Limit exeeded'
};

export const categoryOptionsObject = {
    'ACCOUNT_UPDATE': 'Account update',
    'PAYMENT_UPDATE': 'Payment update',
    'PERSONAL_FINANCE_UPDATE': 'Personal finance update',
    'SHIPPING_UPDATE': 'Shipping update',
    'RESERVATION_UPDATE': 'Reservation update',
    'ISSUE_RESOLUTION': 'Issue Resolution',
    'APPOINTMENT_UPDATE': 'Appointment update',
    'TRANSPORTATION_UPDATE': 'Transaportation update',
    'TICKET_UPDATE': 'Ticket update',
    'ALERT_UPDATE': 'Alert update',
    'AUTO_REPLY': 'Auto reply',
    'TRANSACTIONAL': 'Transactional',
    'MARKETING': 'Marketing',
    'OTP': 'Otp',
};

export const categoryOptions = [
    {
        label: 'Account update', value: 'ACCOUNT_UPDATE'
    },
    {
        label: 'Payment update', value: 'PAYMENT_UPDATE'
    },
    {
        label: 'Personal finance update', value: 'PERSONAL_FINANCE_UPDATE'
    },
    {
        label: 'Shipping update', value: 'SHIPPING_UPDATE'
    },
    {
        label: 'Reservation update', value: 'RESERVATION_UPDATE'
    },
    {
        label: 'Issue Resolution', value: 'ISSUE_RESOLUTION'
    },
    {
        label: 'Appointment update', value: 'APPOINTMENT_UPDATE'
    },
    {
        label: 'Transaportation update', value: 'TRANSPORTATION_UPDATE'
    },
    {
        label: 'Ticket update', value: 'TICKET_UPDATE'
    },
    {
        label: 'Alert update', value: 'ALERT_UPDATE'
    },
    {
        label: 'Auto reply', value: 'AUTO_REPLY'
    },
    {
        label: 'Transactional', value: 'TRANSACTIONAL'
    },
    {
        label: 'Marketing', value: 'MARKETING'
    },
    {
        label: 'Otp', value: 'OTP'
    }
];

export const repeatOptions = {
    "Once" : "Once",
    "Multiple" : "Multiple Times"
}

export const languageOptions = [
    {
        label: 'Afrikaans', value: 'af'
    },
    {
        label: 'Albanian', value: 'sq'
    },
    {
        label: 'Arabic', value: 'ar'
    },
    {
        label: 'Azerbaijani', value: 'az'
    },
    {
        label: 'Bengali', value: 'bn'
    },
    {
        label: 'Bulgarian', value: 'bg'
    },
    {
        label: 'Catalan', value: 'ca'
    },
    {
        label: 'Chinese (CHN)', value: 'zh_CN'
    },
    {
        label: 'Chinese (HKG)', value: 'zh_HK'
    },
    {
        label: 'Chinese (TAI)', value: 'zh_TW'
    },
    {
        label: 'Croatian', value: 'hr'
    },
    {
        label: 'Czech', value: 'cs'
    },
    {
        label: 'Danish', value: 'da'
    },
    {
        label: 'Dutch', value: 'nl'
    },
    {
        label: 'English', value: 'en'
    },
    {
        label: 'English (UK)', value: 'en_GB'
    },
    {
        label: 'English (US)', value: 'en_US'
    },
    {
        label: 'Estonian', value: 'et'
    },
    {
        label: 'Filipino', value: 'fil'
    },
    {
        label: 'Finnish', value: 'fi'
    },
    {
        label: 'French', value: 'fr'
    },
    {
        label: 'Georgian', value: 'ka'
    },
    {
        label: 'German', value: 'de'
    },
    {
        label: 'Greek', value: 'el'
    },
    {
        label: 'Gujarati', value: 'gu'
    },
    {
        label: 'Hausa', value: 'ha'
    },
    {
        label: 'Hebrew', value: 'he'
    },
    {
        label: 'Hindi', value: 'hi'
    },
    {
        label: 'Hungarian', value: 'hu'
    },
    {
        label: 'Indonesian', value: 'id'
    },
    {
        label: 'Irish', value: 'ga'
    },
    {
        label: 'Italian', value: 'it'
    },
    {
        label: 'Japanese', value: 'ja'
    },
    {
        label: 'Kannada', value: 'kn'
    },
    {
        label: 'Kazakh', value: 'kk'
    },
    {
        label: 'Kinyarwanda', value: 'rw_RW'
    },
    {
        label: 'Korean', value: 'ko'
    },
    {
        label: 'Kyrgyz (Kyrgyzstan)', value: 'ky_KG'
    },
    {
        label: 'Lao', value: 'lo'
    },
    {
        label: 'Latvian', value: 'lv'
    },
    {
        label: 'Lithuanian', value: 'lt'
    },
    {
        label: 'Macedonian', value: 'mk'
    },
    {
        label: 'Malay', value: 'ms'
    },
    {
        label: 'Malayalam', value: 'ml'
    },
    {
        label: 'Marathi', value: 'mr'
    },
    {
        label: 'Norwegian', value: 'nb'
    },
    {
        label: 'Persian', value: 'fa'
    },
    {
        label: 'Polish', value: 'pl'
    },
    {
        label: 'Portuguese (BR)', value: 'pt_BR'
    },
    {
        label: 'Portuguese (POR)', value: 'pt_PT'
    },
    {
        label: 'Punjabi', value: 'pa'
    },
    {
        label: 'Romanian', value: 'ro'
    },
    {
        label: 'Russian', value: 'ru'
    },
    {
        label: 'Serbian', value: 'sr'
    },
    {
        label: 'Slovak', value: 'sk'
    },
    {
        label: 'Slovenian', value: 'sl'
    },
    {
        label: 'Spanish', value: 'es'
    },
    {
        label: 'Spanish (ARG)', value: 'es_AR'
    },
    {
        label: 'Spanish (SPA)', value: 'es_ES'
    },
    {
        label: 'Spanish (MEX)', value: 'es_MX'
    },
    {
        label: 'Swahili', value: 'sw'
    },
    {
        label: 'Swedish', value: 'sv'
    },
    {
        label: 'Tamil', value: 'ta'
    },
    {
        label: 'Telugu', value: 'te'
    },
    {
        label: 'Thai', value: 'th'
    },
    {
        label: 'Turkish', value: 'tr'
    },
    {
        label: 'Ukrainian', value: 'uk'
    },
    {
        label: 'Urdu', value: 'ur'
    },
    {
        label: 'Uzbek', value: 'uz'
    },
    {
        label: 'Vietnamese', value: 'vi'
    },
    {
        label: 'Zulu', value: 'zu'
    }
];

export const languageOptionsObject = {
    "af" : "Afrikaans",
    "sq" : "Albanian",
    "ar" : "Arabic",
    "az" : "Azerbaijani",
    "bn" : "Bengali",
    "bg" : "Bulgarian",
    "ca ": "Catalan",
    "zh_CN" : "Chinese (CHN)",
    "zh_HK" : "Chinese (HKG)",
    "zh_TW" : "Chinese (TAI)",
    "hr" : "Croatian",
    "cs" : "Czech",
    "da" : "Danish",
    "nl" :"Dutch",
    "en" : "English",
    "en_GB" : "English (UK)",
    "en_US" : "English (US)",
    "et" : "Estonian",
    "fil" : "Filipino",
    "fi" : "Finnish",
    "fr" : "French",
    "ka" : "Georgian",
    "de" : "German",
    "el" : "Greek",
    "gu" : "Gujarati",
    "ha" : "Hausa",
    "he" : "Hebrew",
    "hi" : "Hindi",
    "hu" : "Hungarian",
    "id" : "Indonesian",
    "ga" : "Irish",
    "it" : "Italian",
    "ja" : "Japanese",
    "kn" : "Kannada",
    "kk" : "Kazakh",
    "rw_RW" : "Kinyarwanda",
    "ko" : "Korean",
    "ky_KG" : "Kyrgyz (Kyrgyzstan)",
    "lo" : "Lao",
    "lv" : "Latvian",
    "lt" : "Lithuanian",
    "mk" : "Macedonian",
    "ms" : "Malay",
    "ml" : "Malayalam",
    "mr" : "Marathi",
    "nb" : "Norwegian",
    "fa" : "Persian",
    "pl" : "Polish",
    "pt_BR" : "Portuguese (BR)",
    "pt_PT" : "Portuguese (POR)",
    "pa" : "Punjabi",
    "ro" : "Romanian",
    "ru" : "Romanian",
    "sr" : "Serbian",
    "sk" : "Slovak",
    "sl" : "Slovenian",
    "es" : "Spanish",
    "es_AR" : "Spanish (ARG)",
    "es_ES" : "Spanish (SPA)",
    "es_MX" : "Spanish (MEX)",
    "sw" : "Swahili",
    "sv" : "Swedish",
    "ta" : "Tamil",
    "te" : "Telugu",
    "th" : "Thai",
    "tr" : "Turkish",
    "uk" : "Ukrainian",
    "ur" : "Urdu",
    "uz" : "Uzbek",
    "vi" : "Vietnamese",
    "zu" : "Zulu"
};
